/**
 * 組合路徑片段與可選的 query string，產生一個相對路徑 URL。
 * @param segments 依序組成路徑的片段，會自動用 "/" 串接
 * @param queryParams 選填的 query string 參數，值為 undefined 的 key 會被忽略
 * @returns 組合後的相對路徑，例如 buildUrl(["a", "b", 1], { x: 2 }) → "/a/b/1?x=2"
 */
export default function buildUrl(
  segments: (string | number)[],
  queryParams?: Record<string, string | number | undefined>,
): string {
  const path = `/${segments.join("/")}`;
  if (!queryParams) return path;
  const query = Object.entries(queryParams)
    .filter((entry): entry is [string, string | number] => entry[1] !== undefined)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  return query ? `${path}?${query}` : path;
}
